import Index from '@/components/meta/Index.vue'
import Enterprise from '@/components/meta/enterprise/Index.vue'
import Park from '@/components/meta/park/Index.vue'
import ParkLocate from '@/components/meta/park/Locate.vue'

import Land from '@/components/meta/land/Index.vue'
import LandLocate from '@/components/meta/land/Locate.vue'

import Person from '@/components/meta/person/Index.vue'
import PersonList from "@/components/meta/person/PersonList";
import PersonAdd from "@/components/meta/person/PersonAdd";
import PersonEditor from "@/components/meta/person/PersonEditor";

import enterpriseEditor from "@/components/meta/enterprise/Editor";
export default {
  path: 'meta',
  component: Index,
  children: [
    /**
     * 主体管理
     */
    {
      path: 'enterprise',
      component: Enterprise
    },
    {
      path: 'enterprise-editor',
      component: enterpriseEditor
    },
    /**
     * 园区管理
     */
    {
      path: 'park',
      component: Park
    },
    {
      path: 'park/locate/:id',
      component: ParkLocate
    },
    /**
     * 地块管理
     */
    {
      path: 'land',
      component: Land,
    },
    {
      path: 'land/locate/:id',
      component: LandLocate
    },
    /**
     * 人员管理
     */
    {
      path: 'person',
      component: Person,
      redirect:'person/list',
      children: [
        {
        path: 'list',
        component: PersonList
        },
        {
          path: 'add',
          component: PersonAdd
        },
        {
          path: 'editor/:id',
          component: PersonEditor
        },
        ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/meta.js